import { useState } from 'react';
import { SVGIcon } from '../SVGIcon';
import { BadgeStatusType } from '../Badge/BadgeTypes';
import { Badge } from '../Badge/Badge';
import { TiresControlMobileSide } from './TiresControlMobileSide';
import type { TiresControlProps, TirePosition } from './TiresControl.types';

export const TiresControlMobile = ({
  tires,
  hasSecondSet = false,
  expertSummary,
  onTireSelect,
  selectedPosition: controlledSelectedPosition,
}: TiresControlProps) => {
  const [internalSelectedPosition, setInternalSelectedPosition] = useState<TirePosition | null>(null);

  const selectedPosition = controlledSelectedPosition ?? internalSelectedPosition;

  const handleTireClick = (position: TirePosition) => {
    if (onTireSelect) {
      onTireSelect(position);
    }
    setInternalSelectedPosition(position);
  };

  const getTireByPosition = (position: TirePosition) => {
    return tires.find((tire) => tire.position === position);
  };

  const frontLeftTire = getTireByPosition('front-left');
  const frontRightTire = getTireByPosition('front-right');
  const rearLeftTire = getTireByPosition('rear-left');
  const rearRightTire = getTireByPosition('rear-right');

  return (
    <div className="space-y-4 w-full">
      {/* Strona lewa */}
      <TiresControlMobileSide
        side="left"
        frontTire={frontLeftTire}
        rearTire={rearLeftTire}
        selectedPosition={selectedPosition}
        onTireSelect={handleTireClick}
      />

      {/* Strona prawa */}
      <TiresControlMobileSide
        side="right"
        frontTire={frontRightTire}
        rearTire={rearRightTire}
        selectedPosition={selectedPosition}
        onTireSelect={handleTireClick}
      />

      {/* Pytanie o drugi komplet */}
      <div className="bg-white border rounded-card border-grayBorder">
        <div className="flex gap-3 items-center px-4 py-3">
          <p className="text-sm font-semibold leading-4 font-inter text-text-primary">
            Czy sprzedający posiada drugi komplet opon?
          </p>
          <Badge
            variant={hasSecondSet ? BadgeStatusType.Success : BadgeStatusType.Error}
            version="v1"
            size="sm"
            badgeText={hasSecondSet ? 'TAK' : 'NIE'}
          />
        </div>
      </div>

      {/* Podsumowanie rzeczoznawcy */}
      {expertSummary && (
        <div className="bg-white border rounded-card border-grayBorder">
          <div className="p-4 bg-gradient-to-b from-gray-100 to-white rounded-card">
            <div className="flex gap-3 items-start">
              <div className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-[10px] bg-primary">
                <SVGIcon name="wheel" size={20} fill="white" />
              </div>
              <div>
                <h4 className="mb-2 text-base font-bold leading-5 font-archivo text-text-primary">
                  Podsumowanie Rzeczoznawcy dotyczące kontroli Ogumienia
                </h4>
                <p className="font-inter text-[13px] font-normal leading-5 text-text-muted">
                  {expertSummary}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
